export default {
    SET_PROCESS_TRACK_ID(state, process_track_id) {
        state.process_track_id = process_track_id;
    },
    
    SET_PROCESS_STEPS(state, steps) {
        state.steps = steps;
    },
    
}